module.exports = "<file-browser></file-browser>"


//////////////////
// WEBPACK FOOTER
// ./src/app/+admin/modules/+file-manager/file-manager.component.html
// module id = 1134
// module chunks = 21